import RocketGif from '../../../assets/images/Rocket.gif';
import AIGif from '../../../assets/images/AI.gif';
import Image2Gif from '../../../assets/images/Image-2.gif';
import MagicWand3Gif from '../../../assets/images/Magic Wand-3.gif';
import HourglassGif from '../../../assets/images/Hourglass.gif';

export const ANIMATIONS = [
  {
    gif: RocketGif,
    title: 'Getting Started',
    subTitle: 'Capturing your intent ',
    progressBarWidth: 56, // in px total width 416
    time: 5, // from 0 - 5 seconds
  },
  {
    gif: AIGif,
    title: 'Igniting the AI engine',
    subTitle: 'Setting the wheels in motion',
    progressBarWidth: 112,
    time: 10, // from 5 - 15 seconds
  },
  {
    gif: Image2Gif,
    title: 'Crafting masterpiece',
    subTitle: 'Imagining, Inspiring and Beautifying',
    progressBarWidth: 186,
    time: 25, // from 15 - 40 seconds
  },
  {
    gif: MagicWand3Gif,
    title: 'Hold tight!',
    subTitle: 'Finalising the magic',
    progressBarWidth: 296,
    time: 40, // from 40 - 80 seconds
  },
  {
    gif: HourglassGif,
    title: 'Almost there!',
    subTitle:
      'Great things take time, thank you for your patience!',
    progressBarWidth: 380,
  },
];
